"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFinalStatementLegacyQuery = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var core_1 = require("../../../core");
function useFinalStatementLegacyQuery(accountId) {
    var api = core_1.configService.getConfig().api;
    var finalStatementEndpoint = "".concat(api.baseUrl, "/bal/final-statement-state/account/").concat(accountId);
    return (0, ui_tools_1.useReactQuery)("cx-final-statement-".concat(accountId), function () {
        return core_1.apiService.get({ url: finalStatementEndpoint });
    });
}
exports.useFinalStatementLegacyQuery = useFinalStatementLegacyQuery;
